export const IMAGES_LOADED = 'images/IMAGES_LOADED';
export const PAGE_RESIZED = 'resize/PAGE_RESIZED';

export function imagesLoaded(images) {
  return {
    type: IMAGES_LOADED,
    payload: images,
  }
}

export function pageResized(width) {
  return {
    type: PAGE_RESIZED,
    payload: width,
  }
}



// WEBPACK FOOTER //
// ./src/state/images/actions/index.js